// Firebase 설정 파일
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// EGMMS V3 Firebase 프로젝트 설정
export const firebaseConfig = {
  apiKey: "AIzaSyBGeKQoh--vKiVqUIG_vFQxOIDAw-dxZrU",
  authDomain: "egmms-v3.firebaseapp.com",
  projectId: "egmms-v3",
  storageBucket: "egmms-v3.firebasestorage.app",
  messagingSenderId: "567775151929",
  appId: "1:567775151929:web:d7d0968aca52086c900ae8",
  measurementId: "G-PGWYREXHYJ"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Firebase 서비스 초기화
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-northeast3');

export default app;
